export default __webpack_public_path__ + "static/media/warning--gate--g1.ef474cd4.png";